import { memo } from 'react'
import { IonIcon } from '@ionic/react'
import { flash } from 'ionicons/icons'

const FlashComponent = () => {
  return <IonIcon icon={flash} color="success" />
}

export const Flash = memo(FlashComponent)
